import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

import Dashboard from './containers/Dashboard';

const routes = [
    {
        // The v2 dashboard now owns "/"; the classic dashboard lives here.
        type: 'simple',
        name: 'dashboard',
        view: Dashboard,
        path: '/v1/dashboard'
    }
]

export default ModuleBootstrapper.getRoutes("dashboard", routes)